export const SUBCATEGORIES = {
  others: { value: 'others', label: 'Others' }
}

export function SUBCATEGORIES_INTL(intl) {
  if (!intl) {
    return
  }
  return {
    value: 'others',
    label: intl.formatMessage({ id: 'label.others', defaultMessage: 'Others' })
  }
}
